import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { isSentryActive } from '../utils/sentry';

/**
 * Tags Sentry error events with the current route so they are filterable by
 * route in the Sentry UI. Renders nothing.
 *
 * No-op when Sentry is not initialized (dev / local builds).
 */
const SentryRouteTracker = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isSentryActive()) {
      return;
    }

    Sentry.setTag('route', pathname);
  }, [pathname]);

  return null;
};

export default SentryRouteTracker;
